import { render, staticRenderFns } from "./ChartDetalheFornecedorVendas.vue?vue&type=template&id=5daee478"
import script from "./ChartDetalheFornecedorVendas.vue?vue&type=script&lang=js"
export * from "./ChartDetalheFornecedorVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports